import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ISiteRequestDetails } from 'src/app/feature/site-rediness-matrix/models/request';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UpdateSiteRequestSelectedIdAction, UpdateSiteApprovalSelectedIdAction } from 'src/app/app-store/site-request/site-request.action';
import { SetPreviousUrl } from 'src/app/app-store/user/user.action';

@Component({
  selector: 'approvals-card-template',
  templateUrl: './card-template.component.html',
  styleUrls: ['./card-template.component.css']
})
export class CardTemplateComponent implements OnInit {

  @Input() data: ISiteRequestDetails;
  @Input() isApproval: boolean;
  @Input() isSelect: boolean;
  @Output() addOrRemove = new EventEmitter<boolean>();
  constructor(private router: Router, private store: Store) { }

  ngOnInit(): void {
  }

  onRequestDetails(id) {
    if (this.isSelect) {
      this.addOrRemove.emit(true);
      return;
    }
    if (this.isApproval) {
      this.store.dispatch(SetPreviousUrl({ url: this.router.url }));
      this.store.dispatch(UpdateSiteApprovalSelectedIdAction({ id }));
      this.router.navigate(['/siteapprovaldetails']);
    } else {
      this.store.dispatch(SetPreviousUrl({ url: this.router.url + '?new=\'\'' }));
      this.store.dispatch(UpdateSiteRequestSelectedIdAction({ id }));
      this.router.navigate(['/reqdetails']);
    }

  }

}
